import { ScriptEnvironment } from 'app/components/scripts/helpers';
import Script from 'app/utils/lib/script';

export const MedalliaScript = () => {
  return (
    <Script
      environment={ScriptEnvironment.ProductionOnly}
      id="medallia"
      serviceName="Medallia"
      src="https://resources.digital-cloud-west.medallia.com/wdcwest/623108/onsite/embed.js"
      strategy="afterInteractive"
    />
  );
};

export default MedalliaScript;
